module.exports = __webpack_public_path__ + "img/Romantikk_Litteraturen1.6ca04f2f.jpg";